export const contentDict = {
  title: "Example Project",                // Display name
  finishDate: new Date("2023-04-08"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.2,
    "C++": 0.6, 
    "Coffee": 0.2, 
  }, 
  description: 
    `This example project's sole purpose is to have a default example.js file 
    within the data folder that you can modify as a template for actual projects. 
    But of course, this project is super relevant for the state-of-the-art and I learned a lot from it.`,
  tags: ["Example", "Template", "Project"],
  github: "https://github.com/kelseyhightower/nocode",    // Can also be `null`
  website: "https://philippwulff.github.io",       // Can also be `null`
  images: [
    require('./img1.jpg'),
    require('./img2.jpg'),
  ],
  coverImg: require('./img1.jpg'),
  mainColor: "#000",
  authors: ["Philipp Wulff"],
  isResearch: false,    // Whether should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }